import { Media } from '@eiq/files/models';

import { QuestionType } from './question-type.enum';
import { Question } from './question.model';
import { SurveyResponseLoop } from './survey-response-loop.interface';

export interface SurveyResolvedResponse {
  questionInstanceId: string;
  questionId: string;
  questionCode: string;
  title: string;
  type: QuestionType;
  answer: string;
  question: Question;
  loop: SurveyResponseLoop | null;
  stimuli: Media[];
  /**
   * Estimated seconds from persisted QuestionDurations, keyed by questionInstanceId.
   * At completion, gaps between the latest question save timestamps (starting at
   * survey start) are split equally among questions sharing each timestamp.
   * Back/resaves replace timestamps and can redistribute those gaps; this is not
   * independently measured question dwell time. Stored fractional precision is retained.
   * Null when no stored value exists, including incomplete attempts and historic
   * responses without timing. The UI rounds to whole seconds and labels this an estimate.
   */
  duration: number | null;
}
